// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  OperatorApi,
  ServerConfiguration,
  createConfiguration,
  RegistryApi,
} from '@digitalasset/utility-api-ts-client';
import React, { useMemo } from 'react';
import { UtilityOperatorApiContext, UtilityRegistryApiContext } from './UtilityApiContext';

interface UtilityApiProps {
  utilityOperatorUrl: string;
}

export const UtilityProxyApiProvider = ({
  utilityOperatorUrl,
  children,
}: React.PropsWithChildren<UtilityApiProps>) => {
  const configuration = createConfiguration({
    baseServer: new ServerConfiguration(utilityOperatorUrl, {}),
  });

  const operatorClient: OperatorApi | undefined = useMemo(() => {
    return new OperatorApi(configuration);
  }, [configuration]);

  const registryClient: RegistryApi | undefined = useMemo(() => {
    return new RegistryApi(configuration);
  }, [configuration]);

  return (
    <UtilityOperatorApiContext.Provider value={operatorClient}>
      <UtilityRegistryApiContext.Provider value={registryClient}>
        {children}
      </UtilityRegistryApiContext.Provider>
    </UtilityOperatorApiContext.Provider>
  );
};
